import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { filter } from 'rxjs';
import { InprogressService } from '@app/shared/services/inprogress.service';
import { NotificationService } from '@progress/kendo-angular-notification';
import { SVGIcon, fileAscxIcon, homeIcon } from '@progress/kendo-svg-icons';
import { announcement } from '@app/shared/customSVGIcons/custom-svg';
import { Language } from '@app/shared/models/language';
import { LanguageService } from '@app/shared/services/language.service';

@Component({
	selector: 'kpa-kpa-layout',
	templateUrl: './kpa-layout.component.html',
	styleUrl: './kpa-layout.component.scss',
})
export class KpaLayoutComponent implements OnInit {
	public router: Router;
	public selectedId = 'dashboard';
	public menuitems = [
		{ path: 'dashboard', name: 'Dashboard', icon: homeIcon },
		{ path: 'sds', name: 'Safety Data Sheets', icon: fileAscxIcon },
		{ path: 'announcements', name: 'Announcements', icon: announcement },
	];
	isMobile = false;
	isSideNavOpen = false;
	isSwitchDialogOpen = false;
	activeRoute: string;

	constructor(
		router: Router,
		private breakpointObserver: BreakpointObserver,
		private activatedRoute: ActivatedRoute,
		private inProgressService: InprogressService,
		private notificationService: NotificationService,
		private readonly languageService: LanguageService
	) {
		this.router = router;
	}

	ngOnInit() {
		this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
			this.activeRoute = this.activatedRoute.firstChild?.snapshot.routeConfig?.path || 'dashboard';
		});

		const lastRoute = sessionStorage.getItem('lastRoute');
		if (lastRoute) {
			this.selectedId = lastRoute;
		}

		this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((result) => {
			this.isMobile = result.matches;
			if (!this.isMobile) {
				this.isSideNavOpen = false;
			}
		});
	}

	toggleSidenav() {
		this.isSideNavOpen = !this.isSideNavOpen;
	}

	onStateChange(event: any) {
		this.selectedId = event.selectedId;
		sessionStorage.setItem('lastRoute', this.selectedId);
		if (this.isMobile) {
			this.isSideNavOpen = false;
		}
	}

	public closeDialog(): void {
		this.isSwitchDialogOpen = false;
	}

	public handleSwitchLanguage(isResetTrainingsEnabled: boolean) {
		this.inProgressService.reset().subscribe({
			next: (result) => {
				if (result) {
					this.languageService.getLanguage().subscribe((result: Language) => {
						var currentLanguageId = result.selectedLanguage.languageId;
						var newLanguageId = 0;
						if (currentLanguageId === 1) {
							newLanguageId = 2;
						} else {
							newLanguageId = 1;
						}
						
						this.languageService.postLanguage(newLanguageId).subscribe((result) => {
							if (result) {
								this.closeDialog();
								location.reload();
							}
						});
					})	
				} else {
					this.closeDialog();
					location.reload();
				}
			},
			error: (err) => {
				this.notificationService.show({
					content: 'Error while resetting trainings.',
					hideAfter: 1000,
					position: { horizontal: 'right', vertical: 'bottom' },
					animation: { type: 'fade', duration: 400 },
					type: { style: 'error', icon: true },
				});
			},
		});
	}

	onLanguageChange() {
		this.activeRoute = this.activatedRoute.firstChild?.snapshot.routeConfig?.path || 'dashboard';
		
		if (this.activeRoute === this.menuitems[0].path) {
			this.isSwitchDialogOpen = true;
		}
	}
}
